(() => {
  if (window.__ccUS) return;
  window.__ccUS = true;

  const cfg = window.__ccCfg || {};
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);
  const onCartPage = () => !!document.querySelector('#mainCart');
  const sget = (k) => { try { return sessionStorage.getItem(k) || ''; } catch (e) { return ''; } };
  const sset = (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} };
  const thousands = (n) => String(Math.round(Number(n) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const money = (cents) => thousands((Number(cents) || 0) / 100) + ' Ft';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // ---------- frissítés ----------
  const getCart = async () => (await nativeFetch(root + 'cart.js?_=' + Date.now(), { cache: 'no-store', headers: { Accept: 'application/json' } })).json();

  const fetchPage = async () => {
    const res = await nativeFetch(location.pathname + '?_=' + Date.now(), { cache: 'no-store' });
    return new DOMParser().parseFromString(await res.text(), 'text/html');
  };

  const swapBlocks = (doc) => {
    ['[data-cc-shipbar]', '[data-cc-upsell]'].forEach((sel) => {
      const a = document.querySelector(sel);
      const b = doc.querySelector(sel);
      if (a) a.innerHTML = b ? b.innerHTML : '';
    });
  };

  const refreshBlocks = async () => { try { swapBlocks(await fetchPage()); } catch (e) {} };

  const refreshPage = async () => {
    try {
      const doc = await fetchPage();
      const a = document.querySelector('#mainCartContainer');
      const b = doc.querySelector('#mainCartContainer');
      if (a && b) a.innerHTML = b.innerHTML; else swapBlocks(doc);
    } catch (e) {}
  };

  // A fiók teljes belsejét cseréljük (a téma is így tesz). Üres kosárral betöltött oldalon
  // nincs <ecx-cart-drwr-frm>, ezért a téma kosárba-tevője nem tudja frissíteni a fiókot.
  const renderDrawer = (sections) => {
    const html = sections && sections['cart-drawer'];
    if (!html) return;
    const nw = new DOMParser().parseFromString(html, 'text/html').querySelector('.js-cart-drawer-wrapper');
    const cur = document.querySelector('#ecxCartDrawer .js-cart-drawer-wrapper');
    if (!nw || !cur) return;
    cur.innerHTML = nw.innerHTML;
    cur.classList.toggle('is-empty', !nw.querySelector('ecx-cart-drwr-frm'));
    document.dispatchEvent(new CustomEvent('cc:cart-updated'));
  };

  const refreshDrawerAndHeader = async () => {
    try {
      const res = await nativeFetch(location.pathname + '?sections=cart-drawer,header-cart-status&_=' + Date.now(), { cache: 'no-store' });
      const sections = await res.json();
      renderDrawer(sections);
      const cur = document.querySelector('#headerCartStatus');
      if (cur && sections['header-cart-status']) {
        const d = new DOMParser().parseFromString(sections['header-cart-status'], 'text/html');
        const s = d.querySelector('.shopify-section');
        cur.innerHTML = s ? s.innerHTML : sections['header-cart-status'];
      }
    } catch (e) {}
  };

  const refreshAll = async () => {
    await refreshDrawerAndHeader();
    if (onCartPage()) await refreshPage();
  };

  // ---------- upsell hozzáadás (egy termék / mind) ----------
  const addItems = async (ids, ctx, btn, msg) => {
    if (!ids.length || btn.disabled) return;
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Hozzáadás…';
    if (msg) msg.textContent = '';
    try {
      const res = await nativeFetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1, properties: { _cc_upsell: ctx } })) })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'add');
      await refreshAll();
      syncGift();
    } catch (err) {
      btn.disabled = false;
      btn.textContent = label;
      if (msg) msg.textContent = 'Ezt most nem sikerült a kosárba tenni. Próbáld meg újra.';
    }
  };

  document.addEventListener('click', (e) => {
    const peek = e.target.closest('[data-cc-peek]');
    if (peek) {
      e.preventDefault();
      const us = document.querySelector('#mainCart [data-cc-upsell]');
      if (!us) return;
      us.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const box = us.querySelector('[data-cc-us]');
      if (box) {
        setTimeout(() => { box.classList.remove('is-flash'); void box.offsetWidth; box.classList.add('is-flash'); }, 450);
      }
      return;
    }
    const one = e.target.closest('[data-cc-us-add]');
    const all = e.target.closest('[data-cc-us-addall]');
    const btn = one || all;
    if (!btn) return;
    e.preventDefault();
    const box = btn.closest('[data-cc-us]');
    const ctx = (box && box.dataset.ctx) || 'page';
    const msg = box && box.querySelector('[data-cc-us-msg]');
    const ids = one ? [btn.dataset.variant] : String(btn.dataset.variants || '').split(',').filter(Boolean);
    addItems(ids, ctx, btn, msg);
  });

  // ---------- mobil "kukucsáló" sáv: jelzi a hajtás alatti ajánlatot a kosár oldalon ----------
  let peekIO = null;
  const buildPeek = () => {
    if (!onCartPage()) return;
    const us = document.querySelector('#mainCart [data-cc-upsell] [data-cc-us]');
    const shipbar = document.querySelector('#mainCart [data-cc-shipbar]');
    const host = shipbar && (shipbar.querySelector('.cc-ms') || shipbar);
    const old = document.querySelector('#mainCart [data-cc-peek]');
    if (!us || !host) { if (old) old.remove(); if (peekIO) { peekIO.disconnect(); peekIO = null; } return; }
    const items = Array.from(us.querySelectorAll('.cc-us__item'));
    const sig = items.map((i) => { const b = i.querySelector('[data-variant]'); return b ? b.dataset.variant : ''; }).join(',');
    if (old && old.dataset.sig === sig && host.contains(old)) return;
    if (old) old.remove();
    if (peekIO) { peekIO.disconnect(); peekIO = null; }
    if (!items.length) return;

    const prices = items.map((i) => parseInt(String((i.querySelector('.cc-us__price') || {}).textContent || '').replace(/\D/g, ''), 10)).filter((n) => n > 0);
    const from = prices.length ? Math.min.apply(null, prices) : 0;
    const thumbs = items.slice(0, 3).map((i, idx) => {
      const img = i.querySelector('.cc-us__pic');
      const src = img ? (img.currentSrc || img.src) : '';
      return src ? '<img src="' + esc(src) + '" alt="" style="--i:' + idx + '">' : '';
    }).join('');
    const n = items.length;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cc-peek';
    btn.dataset.ccPeek = '';
    btn.dataset.sig = sig;
    btn.setAttribute('aria-label', 'Ugrás az ajánlott kiegészítőkhöz');
    btn.innerHTML = '<span class="cc-peek__thumbs">' + thumbs + '</span>' +
      '<span class="cc-peek__tx"><b>' + n + ' ajánlat a kosarad mellé</b><small>' + (from ? 'Már ' + thousands(from) + ' Ft-tól' : 'Egy koppintással hozzáadható') + '</small></span>' +
      '<span class="cc-peek__go" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></span>';
    host.appendChild(btn);

    if ('IntersectionObserver' in window) {
      peekIO = new IntersectionObserver((entries) => {
        btn.classList.toggle('is-hidden', entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -22% 0px' });
      peekIO.observe(us);
    }
  };

  // ---------- ajándék (csak ha a beállításban gift_auto be van kapcsolva) ----------
  // A kosár önmagától betesz egy mintát, ha a Shopify ajándék-kedvezménye (25 000 Ft felett) érvényes;
  // ha a sor a hozzáadás után nem 0 Ft, azonnal kiveszi. Ha a vevő kiveszi, nem rakja vissza.
  const GIFT = Number(cfg.gift_variant) || 0;
  const giftMs = (cfg.milestones || []).find((m) => m.type === 'gift');
  const GIFT_AT = giftMs ? giftMs.at * 100 : 0;
  let syncing = false;

  const giftLine = (cart) => cart.items.find((i) => i.variant_id === GIFT && i.properties && i.properties._cc_gift);
  const removeLine = (line) => nativeFetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) });

  async function syncGift() {
    if (!cfg.gift_auto || !GIFT || !GIFT_AT || syncing) return;
    syncing = true;
    try {
      const cart = await getCart();
      const line = giftLine(cart);
      const base = cart.items.filter((i) => !(i.properties && i.properties._cc_gift)).reduce((s, i) => s + i.original_line_price, 0);
      const key = 'cc_gift_state';
      const st = sget(key);
      let changed = false;
      if (base >= GIFT_AT) {
        if (!line) {
          if (st === 'added') { sset(key, 'declined'); }
          else if (st !== 'declined' && st !== 'ineligible') {
            const res = await nativeFetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: GIFT, quantity: 1, properties: { _cc_gift: '1' } }] })
            });
            if (res.ok) {
              const l2 = giftLine(await getCart());
              if (l2 && l2.final_line_price > 0) { await removeLine(l2); sset(key, 'ineligible'); }
              else sset(key, 'added');
              changed = true;
            }
          }
        } else {
          if (line.final_line_price > 0) { await removeLine(line); sset(key, 'ineligible'); changed = true; }
          else {
            if (st !== 'declined') sset(key, 'added');
            if (line.quantity > 1) {
              await nativeFetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 1 }) });
              changed = true;
            }
          }
        }
      } else {
        if (line) { await removeLine(line); changed = true; }
        sset(key, '');
      }
      if (changed) await refreshAll();
    } catch (e) {
    } finally {
      syncing = false;
    }
  }

  let drawerTimer;
  const scheduleDrawer = () => { clearTimeout(drawerTimer); drawerTimer = setTimeout(refreshDrawerAndHeader, 450); };

  let giftTimer;
  const scheduleSync = () => { clearTimeout(giftTimer); giftTimer = setTimeout(syncGift, 500); };

  // ---------- kosár-hívások figyelése ----------
  window.fetch = function (...args) {
    const url = String((args[0] && args[0].url) || args[0] || '');
    const p = nativeFetch(...args);
    if (/cart\/(add|change|update|clear)/.test(url)) {
      p.then((r) => {
        if (!r.ok) return;
        if (onCartPage() && /cart\/(change|update)/.test(url)) setTimeout(refreshBlocks, 350);
        if (/cart.add/.test(url)) scheduleDrawer();
        scheduleSync();
      }).catch(() => {});
    }
    return p;
  };

  // ---------- legutóbb nézett termékek ----------
  const RK = 'cc_recent';
  const readRecent = () => { try { return JSON.parse(localStorage.getItem(RK) || '[]'); } catch (e) { return []; } };
  const path = location.pathname.match(/\/products\/([^/?#]+)/);
  const current = path ? path[1] : '';
  if (current) {
    try {
      const list = readRecent().filter((h) => h !== current);
      list.unshift(current);
      localStorage.setItem(RK, JSON.stringify(list.slice(0, 8)));
    } catch (e) {}
  }

  const renderRecent = () => {
    document.querySelectorAll('[data-cc-recent]:not([data-done])').forEach(async (el) => {
      el.dataset.done = '1';
      const handles = readRecent().filter((h) => h !== current).slice(0, 4);
      if (!handles.length) return;
      const prods = await Promise.all(handles.map((h) => nativeFetch(root + 'products/' + h + '.js').then((r) => (r.ok ? r.json() : null)).catch(() => null)));
      const cards = prods.filter((p) => p && p.available).map((p) => {
        const img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') : '';
        return '<a class="cc-em__card" href="' + esc(p.url) + '"><span class="cc-em__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span><b>' + esc(p.title) + '</b><span class="cc-em__price">' + money(p.price) + '</span></a>';
      }).join('');
      if (cards) {
        el.innerHTML = '<p class="cc-em__h">Legutóbb nézted</p><div class="cc-em__grid">' + cards + '</div>';
        el.hidden = false;
      }
    });
  };

  let rTimer;
  new MutationObserver(() => { clearTimeout(rTimer); rTimer = setTimeout(() => { renderRecent(); buildPeek(); }, 120); }).observe(document.documentElement, { childList: true, subtree: true });

  const start = () => { renderRecent(); buildPeek(); scheduleSync(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
